/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from "react"
import { graphql } from "gatsby"
import propTypes from "prop-types"
import StudioSlider from "../components/StudioSlider"
import SEO from "../components/Seo"

const BespokePage = ({ data }) => {
  const slides = data.allMarkdownRemark.edges

  return (
    <>
      <SEO title="Bespoke" />
      <StudioSlider slides={slides} />
    </>
  )
}

BespokePage.propTypes = {
  data: propTypes.object.isRequired,
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "aboutslideshow" } } }
      sort: { order: ASC, fields: frontmatter___publish }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            titleES
            bodyES
            image
            video
            display
            titleLogo
          }
          html
        }
      }
    }
  }
`

export default BespokePage
